import $http from '@/libs/axios'

export default class FeaturesApi {
  static async checkLikesCount(pageId: number, postId: any) {
    return (await $http.get(`pages/check-likes/${pageId}/${postId}`)).data
  }

  static async enablePostLikes(data: any) {
    return (await $http.post('pages/enable-likes', data)).data
  }

  static async checkCommenterFeature(pageId: number) {
    return (await $http.get(`pages/check-commenter/${pageId}`)).data
  }

  static async enablePostCommenter(data: any) {
    return (await $http.post('pages/enable-commenter', data)).data
  }

  static async togglePageCommenter(pageId: number) {
    return (await $http.get(`admin/pages/toggle-commenter/${pageId}`)).data
  }

  static async togglePageLiker(pageId: number) {
    return (await $http.get(`admin/pages/toggle-liker/${pageId}`)).data
  }
}
